import { useState } from "react";
import { TwitterFollowButton } from "react-twitter-embed";
import { FaCheck } from "react-icons/fa";
import { MdCached } from "react-icons/md";
import { IconContext } from "react-icons";
import ReactTooltip from "react-tooltip";

import { getThreadIdFromTweet } from "./apiService";

function getReadingMinutes(tweets) {
  const numwords = tweets.reduce((wordcount, tweet) => {
    const tweetWordCount = tweet.text.split(" ").length;
    return wordcount + tweetWordCount;
  }, 0);

  return Math.round(numwords / 200);
}

function ThreadHeader(props) {
  const { thread, hideCopy } = props;
  const [showConfirmCopied, setShowConfirmCopied] = useState(false);
  const [reloading, setReloading] = useState(false);

  const handleCopy = () => {
    const range = document.createRange();
    range.selectNode(document.getElementById("thread-content"));
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();

    setShowConfirmCopied(true);
    setTimeout(() => {
      setShowConfirmCopied(false);
    }, 500);
  };

  const handleReload = async () => {
    setReloading(true);
    const firstTweetId = thread.tweets[0].id;
    await getThreadIdFromTweet(firstTweetId, true, thread._id);
    setReloading(false);

    window.location.reload();
  };

  const ConfirmedCopyIcon = () => (
    <IconContext.Provider value={{ className: "text-lg text-green-500" }}>
      <FaCheck /> <span className="text-sm text-green-500 ml-1">Copied!</span>
    </IconContext.Provider>
  );

  const readingMinutes = getReadingMinutes(thread.tweets);

  return (
    <div className="flex flex-col items-between justify-center p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-start">
          <img
            src={thread.author.profile_image_url}
            alt="profile-img-url"
            className="h-12 w-12 rounded-full"
          />
          <div className="flex flex-col justify-between px-2">
            <span className="font-sans text-xs">{thread.author.name}</span>
            {!hideCopy && thread.author.username && (
              <TwitterFollowButton
                options={{ showCount: !hideCopy }}
                screenName={thread.author.username}
              />
            )}
            <div className="font-sans text-xs text-gray-500">
              {readingMinutes} min read
            </div>
          </div>
        </div>

        {!hideCopy && (
          <div className="flex justify-end">
            <button
              type="button"
              onClick={handleReload}
              className="mr-2 focus:outline-none"
              data-tip="Empty cache and reload thread"
            >
              <MdCached
                className={`text-xl ${reloading ? "animate-spin" : ""}`}
              />
            </button>

            <button
              className="w-24 h-8 flex justify-center items-center font-sans text-sm bg-gray-100 px-4 py-2 rounded-md"
              onClick={handleCopy}
            >
              {showConfirmCopied ? <ConfirmedCopyIcon /> : "Copy"}
            </button>
          </div>
        )}
      </div>
      <ReactTooltip effect="solid" className="font-sans" />
    </div>
  );
}

export default ThreadHeader;
